// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__nnS4B","rootCenter":"LoadMoreObserver_rootCenter__R8BKo","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__32BnH"};